import { configureStore } from '@reduxjs/toolkit';
import {
  apiSlice as hostApiSlice,
  subscriptionManagerApiSlice,
  energySavingsApiSlice,
  powerbiApiSlice,
  expressApiSlice,
  energyAnalysisApiSlice,
  dataforsyningenApiSlice,
  authServerApiSlice,
  apiSliceV2,
  datahubIntegrationApiSlice,
  cvrBaseApiSlice,
} from '../api/apiSlice';
import selectedAccountReducer from './selectedAccountSlice';
import selectedBuildingReducer from './selectedBuildingSlice';
import selectedSubscriptionReducer from './selectedSubscriptionSlice';
import allAccountsReducer from './allAccountsSlice';
import currentUserReducer from './currentUserSlice';
import snackbarReducer from './snackbarSlice';
import timeRangeReducer from '@/features/energyxplorer/redux/timeRangeSlice';
import dataIntegrityReducer from '@/features/portfolio-analysis/redux/dataIntegritySlice';
import { combineReducers } from 'redux';

// auth

const staticReducers = {
  [hostApiSlice.reducerPath]: hostApiSlice.reducer, // remoni api v1 slice
  [subscriptionManagerApiSlice.reducerPath]:
    subscriptionManagerApiSlice.reducer,
  [energySavingsApiSlice.reducerPath]: energySavingsApiSlice.reducer,
  [expressApiSlice.reducerPath]: expressApiSlice.reducer,
  [powerbiApiSlice.reducerPath]: powerbiApiSlice.reducer,
  [energyAnalysisApiSlice.reducerPath]: energyAnalysisApiSlice.reducer,
  [dataforsyningenApiSlice.reducerPath]: dataforsyningenApiSlice.reducer,
  [authServerApiSlice.reducerPath]: authServerApiSlice.reducer,
  [apiSliceV2.reducerPath]: apiSliceV2.reducer,
  [datahubIntegrationApiSlice.reducerPath]: datahubIntegrationApiSlice.reducer,
  [cvrBaseApiSlice.reducerPath]: cvrBaseApiSlice.reducer,

  selectedAccount: selectedAccountReducer,
  selectedBuilding: selectedBuildingReducer,
  selectedSubscription: selectedSubscriptionReducer,
  allAccounts: allAccountsReducer,
  currentUser: currentUserReducer,
  snackbar: snackbarReducer,
  timeRange: timeRangeReducer,
  dataIntegrity: dataIntegrityReducer,
  // auth: authReducer,
};

const createReducer = (asyncReducers) =>
  combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });

export const store = configureStore({
  reducer: createReducer({}),

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(hostApiSlice.middleware)
      .concat(subscriptionManagerApiSlice.middleware)
      .concat(energySavingsApiSlice.middleware)
      .concat(expressApiSlice.middleware)
      .concat(powerbiApiSlice.middleware)
      .concat(energyAnalysisApiSlice.middleware)
      .concat(dataforsyningenApiSlice.middleware)
      .concat(authServerApiSlice.middleware)
      .concat(apiSliceV2.middleware)
      .concat(datahubIntegrationApiSlice.middleware)
      .concat(cvrBaseApiSlice.middleware),
});

export const injectReducer = (key, reducer) => {
  if (!store.asyncReducers[key]) {
    store.asyncReducers[key] = reducer;
    store.replaceReducer(createReducer(store.asyncReducers));
  }
};
